import { FORTUNA_ITEM_DATA_RAW_INTER } from './constant';
import { convertDateToDDMMYYYY } from '../../lib/lang/service';

export const convert = (fortunaList: FORTUNA_ITEM_DATA_RAW_INTER[]) => {
  return fortunaList.map((fortuna) => ({
    ...fortuna,
    createDate: convertDateToDDMMYYYY(fortuna.createDate),
  }));
};
